import { Component, output, OutputEmitterRef } from '@angular/core';
import { MOBILE_APP_STORE_LINKS } from '@improver/app-config';
import { ButtonComponent, LinkButtonComponent } from '@improver/components/buttons';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lay-improver-mobile-banner',
  templateUrl: './improver-mobile-banner.component.html',
  styleUrl: './improver-mobile-banner.component.scss',
  imports: [ButtonComponent, TranslateModule, LinkButtonComponent],
})
export class ImproverMobileBannerComponent {
  readonly bannerDismissed: OutputEmitterRef<boolean> = output();

  dismissBanner() {
    this.bannerDismissed.emit(true);
  }

  openApp() {
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.includes('android')) {
      window.open(MOBILE_APP_STORE_LINKS.ANDROID, '_blank');

      return;
    }

    if (/ipad|iphone|ipod/.test(userAgent)) {
      window.open(MOBILE_APP_STORE_LINKS.IOS, '_blank');
    }
  }
}
